import React from 'react'

import { Body3, Heading6, Join, Space } from '@gousto-internal/citrus-react'

interface RecipeCustomisationPaintedDoorDialogueProps {
  firstName?: string
}

export const RecipeCustomisationPaintedDoorDialogue: React.FC<
  RecipeCustomisationPaintedDoorDialogueProps
> = ({ firstName }) => (
  <Join with={<Space size={4} direction="vertical" />}>
    <Heading6>{firstName ? `${firstName}, t` : 'T'}hanks for showing interest</Heading6>
    <Body3>
      We&apos;re testing out a feature that&apos;ll let you add protein to your meals. We&apos;re
      sorry we can&apos;t do this right now, but we&apos;ll make sure you&apos;re the first to know
      when it&apos;s up and running. If you like, you can still add this recipe to your box.
    </Body3>
  </Join>
)
